// Standort-spezifische Sidebar-Links.
//
// Lege eine neue Datei nach dem Schema "<LOCATION_KEY>.js" in diesem Ordner an
// (z. B. "HG.js", "HT.js"). Der Key muss exakt dem Wert von
// `claims.location` (siehe Vuex-Store getter `userlocation`) entsprechen.
// Existiert für einen Standort keine eigene Datei, wird `default.js` verwendet.
//
// Wichtig: webpacks `require.context` ist nur zur Build-Zeit verfügbar – wir
// listen die Standorte deshalb explizit auf. Beim Hinzufügen eines neuen
// Standorts hier einfach den Import + Map-Eintrag ergänzen.

import defaultLinks from './default'
import HT from './HT'
import HG from './HG'

const sidebarLinksByLocation = {
  HT,
  HG
}

export function getSidebarLinksForLocation (location) {
  if (location && Object.prototype.hasOwnProperty.call(sidebarLinksByLocation, location)) {
    return sidebarLinksByLocation[location]
  }
  return defaultLinks
}

export { sidebarLinksByLocation, defaultLinks }

// Default-Export bleibt ein Array (Rückwärtskompatibilität mit dem bisherigen
// `import sidebarLinks from './sidebarLinks'` in main.js).
export default defaultLinks
